import type { CardDefinition } from '../core/types';

export const cardDefinitions: CardDefinition[] = [
  {
    id: 'drive_back',
    name: "Repel",
    description: 'Deal 6 damage.',
    cost: 1,
    type: 'attack',
    rarity: 'starter',
    target: 'enemy',
    effects: [{ kind: 'damage', amount: 6 }],
    upgrade: {
      name: "Repel+",
      description: 'Deal 9 damage.',
      effects: [{ kind: 'damage', amount: 9 }],
    },
  },
  {
    id: 'brace',
    name: "Field Brace",
    description: 'Gain 5 Block.',
    cost: 1,
    type: 'skill',
    rarity: 'starter',
    target: 'self',
    effects: [{ kind: 'block', amount: 5 }],
    upgrade: {
      name: "Field Brace+",
      description: 'Gain 8 Block.',
      effects: [{ kind: 'block', amount: 8 }],
    },
  },
  {
    id: 'bellows_kick',
    name: "Primer Kick",
    description: 'Deal 3 damage. Stoke 1 Heat.',
    cost: 1,
    type: 'attack',
    rarity: 'starter',
    target: 'enemy',
    effects: [
      { kind: 'damage', amount: 3 },
      { kind: 'heat', amount: 1 },
    ],
    upgrade: {
      name: "Primer Kick+",
      description: 'Deal 6 damage. Stoke 1 Heat.',
      effects: [
        { kind: 'damage', amount: 6 },
        { kind: 'heat', amount: 1 },
      ],
    },
  },
  {
    id: 'rusted_cleaver',
    name: "Extraction Cleaver",
    description: 'Gear 4. Deal 13 damage.',
    cost: 2,
    type: 'attack',
    rarity: 'starter',
    target: 'enemy',
    gear: { maxDurability: 4 },
    effects: [{ kind: 'damage', amount: 13 }],
    upgrade: {
      name: "Extraction Cleaver+",
      description: 'Gear 5. Deal 17 damage.',
      gear: { maxDurability: 5 },
      effects: [{ kind: 'damage', amount: 17 }],
    },
  },
  {
    id: 'furnace_sweep',
    name: "Purge Sweep",
    description: 'Deal 5 damage to all enemies. Stoke 1 Heat.',
    cost: 1,
    type: 'attack',
    rarity: 'common',
    target: 'all_enemies',
    effects: [
      { kind: 'damage', amount: 5, target: 'all' },
      { kind: 'heat', amount: 1 },
    ],
    upgrade: {
      name: "Purge Sweep+",
      description: 'Deal 8 damage to all enemies. Stoke 1 Heat.',
      effects: [
        { kind: 'damage', amount: 8, target: 'all' },
        { kind: 'heat', amount: 1 },
      ],
    },
  },
  {
    id: 'quench',
    name: "Cooling Cycle",
    description: 'Gain 7 Block. Cool 2 Heat.',
    cost: 1,
    type: 'skill',
    rarity: 'common',
    target: 'self',
    effects: [
      { kind: 'block', amount: 7 },
      { kind: 'heat', amount: -2 },
    ],
    upgrade: {
      name: "Cooling Cycle+",
      description: 'Gain 10 Block. Cool 2 Heat.',
      effects: [
        { kind: 'block', amount: 10 },
        { kind: 'heat', amount: -2 },
      ],
    },
  },
  {
    id: 'spare_plates',
    name: "Spare Baffles",
    description: 'Gain 8 Block.',
    cost: 1,
    type: 'skill',
    rarity: 'common',
    target: 'self',
    effects: [{ kind: 'block', amount: 8 }],
    upgrade: {
      name: "Spare Baffles+",
      description: 'Gain 12 Block.',
      effects: [{ kind: 'block', amount: 12 }],
    },
  },
  {
    id: 'patch_kit',
    name: "Field Seal Kit",
    description: 'Repair 1 Durability on a damaged Gear. Exhaust.',
    cost: 1,
    type: 'skill',
    rarity: 'common',
    target: 'self',
    exhaust: true,
    effects: [{ kind: 'repair', amount: 1 }],
    upgrade: {
      name: "Field Seal Kit+",
      description: 'Repair 2 Durability on a damaged Gear. Exhaust.',
      effects: [{ kind: 'repair', amount: 2 }],
    },
  },
  {
    id: 'guarded_strike',
    name: "Guarded Strike",
    description: 'Deal 5 damage. Gain 5 Block.',
    cost: 1,
    type: 'attack',
    rarity: 'common',
    target: 'enemy',
    effects: [
      { kind: 'damage', amount: 5 },
      { kind: 'block', amount: 5 },
    ],
    upgrade: {
      name: "Guarded Strike+",
      description: 'Deal 7 damage. Gain 7 Block.',
      effects: [
        { kind: 'damage', amount: 7 },
        { kind: 'block', amount: 7 },
      ],
    },
  },
  {
    id: 'slag_throw',
    name: "Shard Cast",
    description: 'Deal 7 damage. At 2+ Heat, Temper 1 to apply 2 Vulnerable.',
    cost: 1,
    type: 'attack',
    rarity: 'common',
    target: 'enemy',
    effects: [
      { kind: 'damage', amount: 7 },
      {
        kind: 'if_heat',
        minimum: 2,
        consume: 1,
        effects: [{ kind: 'status', status: 'vulnerable', amount: 2, target: 'selected' }],
      },
    ],
    upgrade: {
      name: "Shard Cast+",
      description: 'Deal 10 damage. At 2+ Heat, Temper 1 to apply 2 Vulnerable.',
      effects: [
        { kind: 'damage', amount: 10 },
        {
          kind: 'if_heat',
          minimum: 2,
          consume: 1,
          effects: [{ kind: 'status', status: 'vulnerable', amount: 2, target: 'selected' }],
        },
      ],
    },
  },
  {
    id: 'iron_rhythm',
    name: "Pump Cadence",
    description: 'Draw 2 cards. Stoke 1 Heat.',
    cost: 1,
    type: 'skill',
    rarity: 'common',
    target: 'self',
    effects: [
      { kind: 'draw', amount: 2 },
      { kind: 'heat', amount: 1 },
    ],
    upgrade: {
      name: "Pump Cadence+",
      description: 'Draw 3 cards. Stoke 1 Heat.',
      effects: [
        { kind: 'draw', amount: 3 },
        { kind: 'heat', amount: 1 },
      ],
    },
  },
  {
    id: 'bolt_driver',
    name: "Anchor Driver",
    description: 'Gear 5. Deal 8 damage.',
    cost: 1,
    type: 'attack',
    rarity: 'common',
    target: 'enemy',
    gear: { maxDurability: 5 },
    effects: [{ kind: 'damage', amount: 8 }],
    upgrade: {
      name: "Anchor Driver+",
      description: 'Gear 6. Deal 11 damage.',
      gear: { maxDurability: 6 },
      effects: [{ kind: 'damage', amount: 11 }],
    },
  },
  {
    id: 'chain_lash',
    name: "Tether Lash",
    description: 'Gear 5. Deal 5 damage. Apply 1 Weak.',
    cost: 1,
    type: 'attack',
    rarity: 'common',
    target: 'enemy',
    gear: { maxDurability: 5 },
    effects: [
      { kind: 'damage', amount: 5 },
      { kind: 'status', status: 'weak', amount: 1, target: 'selected' },
    ],
    upgrade: {
      name: "Tether Lash+",
      description: 'Gear 5. Deal 8 damage. Apply 1 Weak.',
      effects: [
        { kind: 'damage', amount: 8 },
        { kind: 'status', status: 'weak', amount: 1, target: 'selected' },
      ],
    },
  },
  {
    id: 'banked_coals',
    name: "Primed Reservoir",
    description: 'Draw 1 card. Stoke 2 Heat. Exhaust.',
    cost: 0,
    type: 'skill',
    rarity: 'common',
    target: 'self',
    exhaust: true,
    effects: [
      { kind: 'draw', amount: 1 },
      { kind: 'heat', amount: 2 },
    ],
    upgrade: {
      name: "Primed Reservoir+",
      description: 'Draw 1 card. Stoke 3 Heat. Exhaust.',
      effects: [
        { kind: 'draw', amount: 1 },
        { kind: 'heat', amount: 3 },
      ],
    },
  },
  {
    id: 'folded_rampart',
    name: "Folded Barrier",
    description: 'Gain 6 Block. At 3+ Heat, Temper 1 to gain 5 more Block.',
    cost: 1,
    type: 'skill',
    rarity: 'common',
    target: 'self',
    effects: [
      { kind: 'block', amount: 6 },
      { kind: 'if_heat', minimum: 3, consume: 1, effects: [{ kind: 'block', amount: 5 }] },
    ],
    upgrade: {
      name: "Folded Barrier+",
      description: 'Gain 8 Block. At 3+ Heat, Temper 1 to gain 6 more Block.',
      effects: [
        { kind: 'block', amount: 8 },
        { kind: 'if_heat', minimum: 3, consume: 1, effects: [{ kind: 'block', amount: 6 }] },
      ],
    },
  },
  {
    id: 'cinder_etch',
    name: "Vent Scorch",
    description: 'Apply 3 Burning. At 2+ Heat, deal 4 damage.',
    cost: 1,
    type: 'skill',
    rarity: 'common',
    target: 'enemy',
    effects: [
      { kind: 'status', status: 'burning', amount: 3, target: 'selected' },
      { kind: 'if_heat', minimum: 2, effects: [{ kind: 'damage', amount: 4 }] },
    ],
    upgrade: {
      name: "Vent Scorch+",
      description: 'Apply 4 Burning. At 2+ Heat, deal 6 damage.',
      effects: [
        { kind: 'status', status: 'burning', amount: 4, target: 'selected' },
        { kind: 'if_heat', minimum: 2, effects: [{ kind: 'damage', amount: 6 }] },
      ],
    },
  },
  {
    id: 'tempering_blow',
    name: "Catalytic Release",
    description: 'If you have 2 Heat, Temper 2 to deal 18 damage.',
    cost: 1,
    type: 'attack',
    rarity: 'uncommon',
    target: 'enemy',
    effects: [
      {
        kind: 'if_heat',
        minimum: 2,
        consume: 2,
        effects: [{ kind: 'damage', amount: 18 }],
      },
    ],
    upgrade: {
      name: "Catalytic Release+",
      description: 'If you have 2 Heat, Temper 2 to deal 24 damage.',
      effects: [
        {
          kind: 'if_heat',
          minimum: 2,
          consume: 2,
          effects: [{ kind: 'damage', amount: 24 }],
        },
      ],
    },
  },
  {
    id: 'blast_shield',
    name: "Isolation Shield",
    description: 'Gain 13 Block. Cool 3 Heat.',
    cost: 2,
    type: 'skill',
    rarity: 'uncommon',
    target: 'self',
    effects: [
      { kind: 'block', amount: 13 },
      { kind: 'heat', amount: -3 },
    ],
    upgrade: {
      name: "Isolation Shield+",
      description: 'Gain 18 Block. Cool 3 Heat.',
      effects: [
        { kind: 'block', amount: 18 },
        { kind: 'heat', amount: -3 },
      ],
    },
  },
  {
    id: 'serrated_guard',
    name: "Spiked Guard",
    description: 'Gain 7 Block and 3 Thorns.',
    cost: 1,
    type: 'skill',
    rarity: 'uncommon',
    target: 'self',
    effects: [
      { kind: 'block', amount: 7 },
      { kind: 'status', status: 'thorns', amount: 3, target: 'self' },
    ],
    upgrade: {
      name: "Spiked Guard+",
      description: 'Gain 10 Block and 4 Thorns.',
      effects: [
        { kind: 'block', amount: 10 },
        { kind: 'status', status: 'thorns', amount: 4, target: 'self' },
      ],
    },
  },
  {
    id: 'redline_saw',
    name: "Redline Cutter",
    description: 'Gear 3. Deal 7 damage twice. Stoke 2 Heat.',
    cost: 2,
    type: 'attack',
    rarity: 'uncommon',
    target: 'enemy',
    gear: { maxDurability: 3 },
    effects: [
      { kind: 'damage', amount: 7, hits: 2 },
      { kind: 'heat', amount: 2 },
    ],
    upgrade: {
      name: "Redline Cutter+",
      description: 'Gear 3. Deal 9 damage twice. Stoke 2 Heat.',
      effects: [
        { kind: 'damage', amount: 9, hits: 2 },
        { kind: 'heat', amount: 2 },
      ],
    },
  },
  {
    id: 'forge_tongs',
    name: "Extraction Tongs",
    description: 'Gear 5. Gain 9 Block. Cool 1 Heat.',
    cost: 1,
    type: 'skill',
    rarity: 'uncommon',
    target: 'self',
    gear: { maxDurability: 5 },
    effects: [
      { kind: 'block', amount: 9 },
      { kind: 'heat', amount: -1 },
    ],
    upgrade: {
      name: "Extraction Tongs+",
      description: 'Gear 6. Gain 12 Block. Cool 1 Heat.',
      gear: { maxDurability: 6 },
      effects: [
        { kind: 'block', amount: 12 },
        { kind: 'heat', amount: -1 },
      ],
    },
  },
  {
    id: 'jury_rig',
    name: "Emergency Bypass",
    description: 'Draw 1 card. If Gear is Broken, Salvage it: repair 2, gain 10 Block, and draw 1 more. Exhaust.',
    cost: 0,
    type: 'skill',
    rarity: 'uncommon',
    target: 'self',
    exhaust: true,
    effects: [
      { kind: 'draw', amount: 1 },
      {
        kind: 'salvage',
        effects: [
          { kind: 'repair', amount: 2 },
          { kind: 'block', amount: 10 },
          { kind: 'draw', amount: 1 },
        ],
      },
    ],
    upgrade: {
      name: "Emergency Bypass+",
      description: 'Draw 1 card. If Gear is Broken, Salvage it: repair 3, gain 14 Block, and draw 2 more. Exhaust.',
      effects: [
        { kind: 'draw', amount: 1 },
        {
          kind: 'salvage',
          effects: [
            { kind: 'repair', amount: 3 },
            { kind: 'block', amount: 14 },
            { kind: 'draw', amount: 2 },
          ],
        },
      ],
    },
  },
  {
    id: 'hammerfall',
    name: "Anchor Hammer",
    description: 'Gear 3. Deal 15 damage. Apply 2 Vulnerable.',
    cost: 2,
    type: 'attack',
    rarity: 'uncommon',
    target: 'enemy',
    gear: { maxDurability: 3 },
    effects: [
      { kind: 'damage', amount: 15 },
      { kind: 'status', status: 'vulnerable', amount: 2, target: 'selected' },
    ],
    upgrade: {
      name: "Anchor Hammer+",
      description: 'Gear 4. Deal 19 damage. Apply 2 Vulnerable.',
      gear: { maxDurability: 4 },
      effects: [
        { kind: 'damage', amount: 19 },
        { kind: 'status', status: 'vulnerable', amount: 2, target: 'selected' },
      ],
    },
  },
  {
    id: 'white_hot_edge',
    name: "Thermal Edge",
    description: 'Gear 4. Deal 7 damage. Apply 3 Burning. Stoke 1 Heat.',
    cost: 1,
    type: 'attack',
    rarity: 'uncommon',
    target: 'enemy',
    gear: { maxDurability: 4 },
    effects: [
      { kind: 'damage', amount: 7 },
      { kind: 'status', status: 'burning', amount: 3, target: 'selected' },
      { kind: 'heat', amount: 1 },
    ],
    upgrade: {
      name: "Thermal Edge+",
      description: 'Gear 4. Deal 9 damage. Apply 4 Burning. Stoke 1 Heat.',
      effects: [
        { kind: 'damage', amount: 9 },
        { kind: 'status', status: 'burning', amount: 4, target: 'selected' },
        { kind: 'heat', amount: 1 },
      ],
    },
  },
  {
    id: 'iron_refrain',
    name: "Breathing Interval",
    description: 'Gain 5 Block. Draw 1 card. At 3+ Heat, Temper 1 to draw 1 more card.',
    cost: 1,
    type: 'skill',
    rarity: 'uncommon',
    target: 'self',
    effects: [
      { kind: 'block', amount: 5 },
      { kind: 'draw', amount: 1 },
      { kind: 'if_heat', minimum: 3, consume: 1, effects: [{ kind: 'draw', amount: 1 }] },
    ],
    upgrade: {
      name: "Breathing Interval+",
      description: 'Gain 8 Block. Draw 1 card. At 3+ Heat, Temper 1 to draw 1 more card.',
      effects: [
        { kind: 'block', amount: 8 },
        { kind: 'draw', amount: 1 },
        { kind: 'if_heat', minimum: 3, consume: 1, effects: [{ kind: 'draw', amount: 1 }] },
      ],
    },
  },
  {
    id: 'spine_of_lorn',
    name: "Bellrose Bracing",
    description: 'Gain 1 Dexterity and 3 Thorns. Exhaust.',
    cost: 1,
    type: 'power',
    rarity: 'uncommon',
    target: 'self',
    exhaust: true,
    effects: [
      { kind: 'status', status: 'dexterity', amount: 1, target: 'self' },
      { kind: 'status', status: 'thorns', amount: 3, target: 'self' },
    ],
    upgrade: {
      name: "Bellrose Bracing+",
      description: 'Gain 2 Dexterity and 4 Thorns. Exhaust.',
      effects: [
        { kind: 'status', status: 'dexterity', amount: 2, target: 'self' },
        { kind: 'status', status: 'thorns', amount: 4, target: 'self' },
      ],
    },
  },
  {
    id: 'molten_verdict',
    name: "Mass Release",
    description: 'If you have 4 Heat, Temper 4 to deal 20 damage to all enemies.',
    cost: 2,
    type: 'attack',
    rarity: 'rare',
    target: 'all_enemies',
    exhaust: true,
    effects: [
      {
        kind: 'if_heat',
        minimum: 4,
        consume: 4,
        effects: [{ kind: 'damage', amount: 20, target: 'all' }],
      },
    ],
    upgrade: {
      name: "Mass Release+",
      description: 'If you have 3 Heat, Temper 3 to deal 24 damage to all enemies.',
      effects: [
        {
          kind: 'if_heat',
          minimum: 3,
          consume: 3,
          effects: [{ kind: 'damage', amount: 24, target: 'all' }],
        },
      ],
    },
  },
  {
    id: 'flashpoint',
    name: "Overprime",
    description: 'Draw 3 cards. Gain 2 Strength. Stoke 3 Heat. Exhaust.',
    cost: 1,
    type: 'skill',
    rarity: 'rare',
    target: 'self',
    exhaust: true,
    effects: [
      { kind: 'draw', amount: 3 },
      { kind: 'status', status: 'strength', amount: 2, target: 'self' },
      { kind: 'heat', amount: 3 },
    ],
    upgrade: {
      name: "Overprime+",
      description: 'Draw 4 cards. Gain 3 Strength. Stoke 3 Heat. Exhaust.',
      effects: [
        { kind: 'draw', amount: 4 },
        { kind: 'status', status: 'strength', amount: 3, target: 'self' },
        { kind: 'heat', amount: 3 },
      ],
    },
  },
  {
    id: 'veinbreaker',
    name: "Intake Breaker",
    description: 'Gear 3. Deal 24 damage. At 3+ Heat, deal 10 more damage.',
    cost: 3,
    type: 'attack',
    rarity: 'rare',
    target: 'enemy',
    gear: { maxDurability: 3 },
    effects: [
      { kind: 'damage', amount: 24 },
      { kind: 'if_heat', minimum: 3, effects: [{ kind: 'damage', amount: 10 }] },
    ],
    upgrade: {
      name: "Intake Breaker+",
      description: 'Gear 4. Deal 28 damage. At 3+ Heat, deal 12 more damage.',
      gear: { maxDurability: 4 },
      effects: [
        { kind: 'damage', amount: 28 },
        { kind: 'if_heat', minimum: 3, effects: [{ kind: 'damage', amount: 12 }] },
      ],
    },
  },
  {
    id: 'foundry_harness',
    name: "Field Recovery Frame",
    description: 'Gear 4. Gain 18 Block. Repair 2 Durability on your most damaged Gear.',
    cost: 2,
    type: 'skill',
    rarity: 'rare',
    target: 'self',
    gear: { maxDurability: 4 },
    effects: [
      { kind: 'block', amount: 18 },
      { kind: 'repair', amount: 2 },
    ],
    upgrade: {
      name: "Field Recovery Frame+",
      description: 'Gear 5. Gain 23 Block. Repair 3 Durability on your most damaged Gear.',
      gear: { maxDurability: 5 },
      effects: [
        { kind: 'block', amount: 23 },
        { kind: 'repair', amount: 3 },
      ],
    },
  },
  {
    id: 'iron_choir',
    name: "Synchronized Pumps",
    description: 'Gain 2 Strength and 2 Dexterity. Stoke 2 Heat. Exhaust.',
    cost: 2,
    type: 'power',
    rarity: 'rare',
    target: 'self',
    exhaust: true,
    effects: [
      { kind: 'status', status: 'strength', amount: 2, target: 'self' },
      { kind: 'status', status: 'dexterity', amount: 2, target: 'self' },
      { kind: 'heat', amount: 2 },
    ],
    upgrade: {
      name: "Synchronized Pumps+",
      description: 'Gain 2 Strength and 2 Dexterity. Stoke 2 Heat. Exhaust.',
      cost: 1,
      effects: [
        { kind: 'status', status: 'strength', amount: 2, target: 'self' },
        { kind: 'status', status: 'dexterity', amount: 2, target: 'self' },
        { kind: 'heat', amount: 2 },
      ],
    },
  },
  {
    id: 'hold_the_deep',
    name: "Hold the Line",
    description: 'Gain 20 Block and 5 Thorns. Cool all Heat. Exhaust.',
    cost: 2,
    type: 'skill',
    rarity: 'rare',
    target: 'self',
    exhaust: true,
    effects: [
      { kind: 'block', amount: 20 },
      { kind: 'status', status: 'thorns', amount: 5, target: 'self' },
      { kind: 'heat', amount: -6 },
    ],
    upgrade: {
      name: "Hold the Line+",
      description: 'Gain 26 Block and 7 Thorns. Cool all Heat. Exhaust.',
      effects: [
        { kind: 'block', amount: 26 },
        { kind: 'status', status: 'thorns', amount: 7, target: 'self' },
        { kind: 'heat', amount: -6 },
      ],
    },
  },
  {
    id: 'choking_dust',
    name: "Containment Dust",
    description: 'Unplayable. Ethereal. Exhausts if it remains in your hand at end of turn.',
    cost: 0,
    type: 'status',
    rarity: 'status',
    target: 'none',
    unplayable: true,
    ethereal: true,
    effects: [],
  },
  {
    id: 'slag_spark',
    name: "Residual Burn",
    description: 'Stoke 2 Heat. Exhaust.',
    cost: 1,
    type: 'status',
    rarity: 'status',
    target: 'self',
    exhaust: true,
    effects: [{ kind: 'heat', amount: 2 }],
  },
  {
    id: 'white_echo',
    name: "Lost Concentration",
    description: 'Gain 1 Weak. Exhaust.',
    cost: 1,
    type: 'status',
    rarity: 'status',
    target: 'self',
    exhaust: true,
    effects: [{ kind: 'status', status: 'weak', amount: 1, target: 'self' }],
  },
];

export const starterDeck = [
  'drive_back',
  'drive_back',
  'drive_back',
  'drive_back',
  'brace',
  'brace',
  'brace',
  'brace',
  'bellows_kick',
  'rusted_cleaver',
];

export const rewardPool = cardDefinitions
  .filter((card) => ['common', 'uncommon', 'rare'].includes(card.rarity))
  .map((card) => card.id);
